import React, { FC } from 'react'
import { BaseFacetProps } from '../types'
import { CategoryFacetConnector, CategoryFacetConnectorProps } from 'connectors/Facets'
import { updateClientSideUrl } from '../helpers/url'
import RadioListFacet from '../components/RadioListFacet'

export const CATEGORIES_MAPPING_ORDER = [
  'All',
  'Paintings',
  'Photography',
  'Drawings',
  'Mixed Media',
  'Sculpture',
  'Collage',
  'Printmaking',
  'Digital',
  'Installation',
]

type SingleCategoryFacetProps = BaseFacetProps &
  CategoryFacetConnectorProps & {
    maxDisplayedItems?: number
  }

const SingleCategoryFacet: FC<SingleCategoryFacetProps> = ({
  baseUrl,
  nextAppRoute,
  // categoryFacets, // Using hardcode for now as requested by product team
  getHref,
  selectedCategory,
  updateCategoryFacetValues,
  maxDisplayedItems = 6,
}) => {
  const handleCategoryFilterClick = (hrefParam: string) => {
    updateClientSideUrl(hrefParam, nextAppRoute)
  }

  const filterOptions = CATEGORIES_MAPPING_ORDER.map((categoryText, index) => {
    const isAllSelected = selectedCategory === '' && categoryText === 'All'
    const isSelected = !!(selectedCategory && selectedCategory === categoryText)
    const href = getHref({
      ['category']: updateCategoryFacetValues('category', categoryText),
      page: '', // Reset Page
    })
    const newUrlPath = `${baseUrl}${href}`

    return {
      text: categoryText,
      selected: isAllSelected || isSelected,
      onClick: () => handleCategoryFilterClick(newUrlPath),
      isHidden: index >= maxDisplayedItems,
      href: newUrlPath,
    }
  })

  return <RadioListFacet facetName='category' filterOptions={filterOptions} />
}

export default CategoryFacetConnector(SingleCategoryFacet)
